import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import { getFirestore } from "@firebase/firestore";
import { app } from '../firebase.js';
import { collection, doc, orderBy, setDoc,query, getDocs, deleteDoc, where, updateDoc} from "@firebase/firestore"; 
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import swal from 'sweetalert';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import defaulProfPic from '../Images/defprofile.png'
import MaskedPhone from '../Components/MaskedPhone';
import { logAdminActivity } from '../utils/activityLogger';
import { normalizeAdminType, resolveAdminRecord } from '../utils/adminAccess';


function NeverJoinedComp() {
    const db = getFirestore(app);
    const auth = getAuth();
    let navigate = useNavigate();
  
    const [studentsList, setStudentList] = useState([]);
    const [countAllData, setcountAllData ] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterCourse, setFilterCourse] = useState('All');
    const [filterCountry, setFilterCountry] = useState('All');
    const [applicationFrom, setApplicationFrom] = useState('');
    const [applicationTo, setApplicationTo] = useState('');
    const [adminRole, setAdminRole] = useState('admin');
    const lastSearchRef = useRef('');
    const lastCourseRef = useRef(filterCourse);
    const lastCountryRef = useRef(filterCountry);
    const lastApplicationFromRef = useRef('');
    const lastApplicationToRef = useRef('');
  
    useEffect(() => {
      const fetchData = async () => {
          const q = query(collection(db, 'users'), orderBy("appDate", 'desc'), where("userStatus", "==", "Did Not Join"));
          const querySnapshot = await getDocs(q);
          const studentsItem = [];
          querySnapshot.forEach((doc) => {
              studentsItem.push({ id: doc.id, ...doc.data() });
          });
          setStudentList(studentsItem);
          setcountAllData(studentsItem.length)
  
      };
  
      fetchData();
    }, []);

    useEffect(() => {
      let cancelled = false;

      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        if (!user) {
          if (!cancelled) {
            setAdminRole('admin');
          }
          return;
        }

        try {
          const adminRecord = await resolveAdminRecord(user);
          if (!cancelled) {
            setAdminRole(normalizeAdminType(adminRecord?.adminType));
          }
        } catch (error) {
          console.error('Failed to load admin role for never joined page:', error);
          if (!cancelled) {
            setAdminRole('admin');
          }
        }
      });

      return () => {
        cancelled = true;
        unsubscribe();
      };
    }, [auth]);

    useEffect(() => {
      const trimmed = searchTerm.trim();
      const timeoutId = setTimeout(() => {
        if (trimmed === lastSearchRef.current) return;
        lastSearchRef.current = trimmed;
        if (trimmed) {
          logAdminActivity({
            action: 'Search',
            details: `Never Joined search: "${trimmed}"`,
            meta: { page: 'Never Joined', query: trimmed }
          });
        }
      }, 600);
      return () => clearTimeout(timeoutId);
    }, [searchTerm]);

    useEffect(() => {
      if (filterCourse === lastCourseRef.current) return;
      lastCourseRef.current = filterCourse;
      logAdminActivity({
        action: 'Filter',
        details: `Never Joined course filter: ${filterCourse}`,
        meta: { page: 'Never Joined', filter: 'course', value: filterCourse }
      });
    }, [filterCourse]);

    useEffect(() => {
      if (filterCountry === lastCountryRef.current) return;
      lastCountryRef.current = filterCountry;
      logAdminActivity({
        action: 'Filter',
        details: `Never Joined country filter: ${filterCountry}`,
        meta: { page: 'Never Joined', filter: 'country', value: filterCountry }
      });
    }, [filterCountry]);

    useEffect(() => {
      if (applicationFrom === lastApplicationFromRef.current) return;
      lastApplicationFromRef.current = applicationFrom;
      logAdminActivity({
        action: 'Filter',
        details: `Never Joined application from: ${applicationFrom || 'Any'}`,
        meta: { page: 'Never Joined', filter: 'applicationFrom', value: applicationFrom || 'Any' }
      });
    }, [applicationFrom]);

    useEffect(() => {
      if (applicationTo === lastApplicationToRef.current) return;
      lastApplicationToRef.current = applicationTo;
      logAdminActivity({
        action: 'Filter',
        details: `Never Joined application to: ${applicationTo || 'Any'}`,
        meta: { page: 'Never Joined', filter: 'applicationTo', value: applicationTo || 'Any' }
      });
    }, [applicationTo]);
  
  
    function viewStudent(userId, studentName) {
      logAdminActivity({
        action: 'View Student',
        details: `Opened student profile: ${studentName || 'student'}`,
        meta: { page: 'Never Joined', studentId: userId, studentName: studentName || '' }
      });
      navigate('/view-student', { state: { myData: userId } });
    }

    const toDateValue = (value) => {
      if (!value) return null;
      const dateObj = value.toDate ? value.toDate() : new Date(value);
      return Number.isNaN(dateObj.getTime()) ? null : dateObj;
    };

    const isSuperAdmin = adminRole === 'superAdmin';
    const uniqueCourses = Array.from(new Set(studentsList.map((student) => student.course).filter(Boolean))).sort();
    const uniqueCountries = Array.from(new Set(studentsList.map((student) => student.nationality).filter(Boolean))).sort();
    const filteredStudents = studentsList.filter((student) => {
      const search = searchTerm.trim().toLowerCase();
      const matchesSearch = !search || [
        student.bio,
        student.course,
        student.nationality,
        isSuperAdmin ? student.phoneNumber : ''
      ].some((value) => String(value || '').toLowerCase().includes(search));

      const matchesCourse = filterCourse === 'All' || student.course === filterCourse;
      const matchesCountry = filterCountry === 'All' || student.nationality === filterCountry;
      const applicationDate = toDateValue(student.appDate);
      const fromDate = applicationFrom ? new Date(`${applicationFrom}T00:00:00`) : null;
      const toDate = applicationTo ? new Date(`${applicationTo}T23:59:59.999`) : null;
      const matchesFromDate = !fromDate || (applicationDate && applicationDate >= fromDate);
      const matchesToDate = !toDate || (applicationDate && applicationDate <= toDate);

      return matchesSearch && matchesCourse && matchesCountry && matchesFromDate && matchesToDate;
    });

    const formatDateTime = (value) => {
      if (!value) return '—';
      const dateObj = toDateValue(value);
      if (!dateObj || Number.isNaN(dateObj.getTime())) return '—';
      const datePart = dateObj.toLocaleDateString();
      const timePart = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      return `${datePart} • ${timePart}`;
    };

    const totalCount = countAllData;
    const filteredCount = filteredStudents.length;
    const tableColumnCount = isSuperAdmin ? 7 : 5;

    return (
      <div className="clientsComp applicationsPage">
        <div className="appsHeader">
          <div>
            <p className="appsKicker">Students</p>
            <h4>Never Joined</h4>
            <p className="appsSubtext">Applicants who did not proceed to enroll.</p>
          </div>
          <div className="appsHeaderStats">
            <div className="appsStatChip">
              <span>All</span>
              <strong>{totalCount}</strong>
            </div>
            <div className="appsStatChip">
              <span>Showing</span>
              <strong>{filteredCount}</strong>
            </div>
          </div>
        </div>

        <div className="appsFiltersCard">
          <div className="appsFilterGroup">
            <div className="w-100">
              <Form.Label className="mb-1">Search students</Form.Label>
              <div className="appsSearch input-group">
                <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
                <Form.Control
                  type="text"
                  placeholder={isSuperAdmin ? "Search name, course, phone..." : "Search name, course, country..."}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="appsFilterGroup">
            <div>
              <Form.Label className="mb-1">Filter by course</Form.Label>
              <Form.Select className="filterSelect" value={filterCourse} onChange={(e) => setFilterCourse(e.target.value)}>
                <option value="All">All Courses</option>
                {uniqueCourses.map((course) => (
                  <option key={course} value={course}>{course}</option>
                ))}
              </Form.Select>
            </div>
            <div>
              <Form.Label className="mb-1">Filter by country</Form.Label>
              <Form.Select className="filterSelect" value={filterCountry} onChange={(e) => setFilterCountry(e.target.value)}>
                <option value="All">All Countries</option>
                {uniqueCountries.map((country) => (
                  <option key={country} value={country}>{country}</option>
                ))}
              </Form.Select>
            </div>
            <div>
              <Form.Label className="mb-1">Application date from</Form.Label>
              <Form.Control
                type="date"
                value={applicationFrom}
                onChange={(e) => setApplicationFrom(e.target.value)}
              />
            </div>
            <div>
              <Form.Label className="mb-1">Application date to</Form.Label>
              <Form.Control
                type="date"
                value={applicationTo}
                onChange={(e) => setApplicationTo(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="appsTableCard">
          <div className="appsTableHeader">
            <h6>Never Joined</h6>
            <span>{filteredCount} results</span>
          </div>
          <div className="appsTableWrap">
            <Table hover responsive className="appsTable">
              <thead>
                <tr>
                  <th>Student</th>
                  <th>Application Date</th>
                  <th>Course</th>
                  <th>Country</th>
                  {isSuperAdmin && <th>Phone</th>}
                  <th>Cohort</th>
                  {isSuperAdmin && <th></th>}
                </tr>
              </thead>
              <tbody>
                {filteredStudents.map((mystudent) => (
                  <tr key={mystudent.id}>
                    <td>
                      <div className="appsStudentCell">
                        <div className='appDefProfPic'>
                          <img src={mystudent.profilePic ? mystudent.profilePic : defaulProfPic} alt="profile" />
                        </div>
                        <div>
                          <p className="appsStudentName">{mystudent.bio || 'Unnamed student'}</p>
                          <span className="appsStudentMeta">{mystudent.course || 'Course not set'}</span>
                        </div>
                      </div>
                    </td>
                    <td>{formatDateTime(mystudent.appDate)}</td>
                    <td>{mystudent.course || '—'}</td>
                    <td>{mystudent.nationality || '—'}</td>
                    {isSuperAdmin && (
                      <td>
                        <MaskedPhone
                          phoneNumber={mystudent.phoneNumber}
                          studentId={mystudent.userId}
                          studentName={mystudent.bio}
                        />
                      </td>
                    )}
                    <td>{mystudent.cohort || '—'}</td>
                    {isSuperAdmin && (
                      <td>
                        <button className='appsViewBtn' onClick={() => viewStudent(mystudent.userId, mystudent.bio)}>
                          View
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
                {filteredStudents.length === 0 && (
                  <tr>
                    <td colSpan={tableColumnCount} className="appsEmptyState">
                      No matching students found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
  
    )
  }
  

export default NeverJoinedComp
